import { createContext, useContext, useState } from "react";
import CatalogModal from "../components/CatalogModal";

const Ctx = createContext({ open: () => {} });

export function CatalogProvider({ children }) {
    const [open, setOpen] = useState(false);
    const [seq, setSeq] = useState(0);
    return (
        <Ctx.Provider value={{ open: () => { setSeq((s) => s + 1); setOpen(true); } }}>
            {children}
            {open && <CatalogModal key={seq} open={true} onClose={() => setOpen(false)} />}
        </Ctx.Provider>
    );
}

export function useCatalog() {
    return useContext(Ctx);
}
